import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useFacility } from '../context/FacilityContext';
import { useAuth } from '../context/AuthContext';
import {
  canAccessFacility,
  accessibleFacilityIds,
} from '../config/facilityAccess';

const ProtectedRoute = ({
  userForbidden,
  superadminOnly = false,
  children,
}) => {
  const { claims, currentUser, userLoading, userVerified } = useAuth();
  const { facilityId, setFacilityId } = useFacility();
  let navigate = useNavigate();

  useEffect(() => {
    const hasRequiredClaims = () => {
      if (superadminOnly) {
        return claims?.superadmin === true;
      }
      if ('superadmin' in claims && claims.superadmin) {
        return true;
      }

      if (
        ('admin' in claims && claims.admin) ||
        ('staff' in claims && claims.staff)
      ) {
        if (canAccessFacility(claims, facilityId)) {
          return true;
        }
        // we will not kick to the front page, but to some allowed facility
        const ids = accessibleFacilityIds(claims);
        if (ids.length > 0) {
          setFacilityId(ids[0]);
          return true;
        }
        return false;
      }

      if (!userForbidden) {
        return true;
      }

      return false;
    };

    if (!userLoading) {
      if (!currentUser || !userVerified) {
        console.error('User not authenticated');
        navigate('/login');
      } else if (!hasRequiredClaims()) {
        console.error('Forbidden');
        navigate('/');
      }
    }
  }, [
    userLoading,
    currentUser,
    userVerified,
    claims,
    facilityId,
    navigate,
    setFacilityId,
    userForbidden,
    superadminOnly,
  ]);

  return children;
};

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
  userForbidden: PropTypes.bool.isRequired,
  superadminOnly: PropTypes.bool,
};

export default ProtectedRoute;
